module.exports = __webpack_public_path__ + "img/image-default.0ebf89b1.svg";